{
  "curricula": {
    "1101_act": "Australian Capital Territory",
    "1101_nsw": "New South Wales",
    "1101_nt": "Northern Territory",
    "1101_qld": "Queensland",
    "1101_sa": "South Australia",
    "1101_tas": "Tasmania",
    "1101_vic": "Victoria",
    "1101_wa": "Western Australia",
    "1201_auk": "Auckland",
    "1201_bop": "Bay of Plenty",
    "1201_can": "Canterbury",
    "1201_gis": "Gisborne",
    "1201_hkb": "Hawke's Bay",
    "1201_mbh": "Marlborough",
    "1201_mwt": "Manawatu-Wanganui",
    "1201_nsn": "Nelson",
    "1201_ntl": "Northland",
    "1201_ota": "Otago",
    "1201_stl": "Southland",
    "1201_tas": "Tasman",
    "1201_tki": "Taranaki",
    "1201_wgn": "Wellington",
    "1201_wko": "Waikato",
    "1201_wtc": "West Coast",
    "other_na": "Other"
  },
  "subjects": {
    "1101_act.accounting": "Accounting",
    "1101_act.advanced_modern_languages": "Advanced Modern Languages",
    "1101_act.agriculture": "Agriculture",
    "1101_act.ancient_history": "Ancient History",
    "1101_act.athlete_development": "Athlete Development",
    "1101_act.automotive_technology": "Automotive Technology",
    "1101_act.beginning_classical_languages": "Beginning Classical Languages",
    "1101_act.beginning_modern_languages": "Beginning Modern Languages",
    "1101_act.biology": "Biology",
    "1101_act.bridging_literacy": "Bridging Literacy",
    "1101_act.bridging_numeracy": "Bridging Numeracy",
    "1101_act.business": "Business",
    "1101_act.business_services": "Business Services",
    "1101_act.chemistry": "Chemistry",
    "1101_act.commerce_integrated": "Commerce Integrated",
    "1101_act.connected_learning": "Connected Learning",
    "1101_act.construction_pathways": "Construction Pathways",
    "1101_act.continuing_classical_languages": "Continuing Classical Languages",
    "1101_act.continuing_modern_languages": "Continuing Modern Languages",
    "1101_act.dance": "Dance",
    "1101_act.data_science": "Data Science",
    "1101_act.design_and_emerging_technologies": "Design and Emerging Technologies",
    "1101_act.design_and_graphics": "Design and Graphics",
    "1101_act.design_and_technology_integrated": "Design and Technology Integrated",
    "1101_act.design_and_textiles": "Design and Textiles",
    "1101_act.designed_environments": "Designed Environments",
    "1101_act.digital_products": "Digital Products",
    "1101_act.digital_technologies": "Digital Technologies",
    "1101_act.drama": "Drama",
    "1101_act.eal": "EAL",
    "1101_act.eal-english_integrated": "EAL-English Integrated",
    "1101_act.early_childhood_studies": "Early Childhood Studies",
    "1101_act.earth_and_environmental_science": "Earth and Environmental Science",
    "1101_act.economics": "Economics",
    "1101_act.education_studies": "Education Studies",
    "1101_act.engineering_studies": "Engineering Studies",
    "1101_act.english": "English",
    "1101_act.english_literature_integrated": "English/Literature Integrated",
    "1101_act.essential_english": "Essential English",
    "1101_act.essential_mathematics": "Essential Mathematics",
    "1101_act.exercise_science": "Exercise Science",
    "1101_act.food_science_and_nutrition": "Food Science and Nutrition",
    "1101_act.food_studies": "Food Studies",
    "1101_act.furniture_making_pathways": "Furniture Making Pathways",
    "1101_act.further_mathematics_integrated": "Further Mathematics Integrated",
    "1101_act.geography": "Geography",
    "1101_act.global_studies": "Global Studies",
    "1101_act.health_science": "Health Science",
    "1101_act.history_integrated": "History Integrated",
    "1101_act.horticulture": "Horticulture",
    "1101_act.hospitality": "Hospitality",
    "1101_act.indigenous_language_and_culture": "Indigenous Language and Culture",
    "1101_act.information_technology_integrated": "Information Technology Integrated",
    "1101_act.interdisciplinary_inquiry": "Interdisciplinary Inquiry",
    "1101_act.interdisciplinary_science": "Interdisciplinary Science",
    "1101_act.legal_studies": "Legal Studies",
    "1101_act.literature": "Literature",
    "1101_act.live_production_and_services": "Live Production and Services",
    "1101_act.mathematical_applications": "Mathematical Applications",
    "1101_act.mathematical_methods": "Mathematical Methods",
    "1101_act.media": "Media",
    "1101_act.metal_products": "Metal Products",
    "1101_act.modern_history": "Modern History",
    "1101_act.music": "Music",
    "1101_act.networking_and_security": "Networking and Security",
    "1101_act.outdoor_and_environmental_education": "Outdoor and Environmental Education",
    "1101_act.outdoor_recreation": "Outdoor Recreation",
    "1101_act.pacific_studies": "Pacific Studies",
    "1101_act.pathways_to_work_and_life_learning": "Pathways to Work and Life Learning",
    "1101_act.philosophy": "Philosophy",
    "1101_act.photography": "Photography",
    "1101_act.physical_education_studies": "Physical Education Studies",
    "1101_act.physics": "Physics",
    "1101_act.politics": "Politics",
    "1101_act.pre-modern_history": "Pre-Modern History",
    "1101_act.psychology": "Psychology",
    "1101_act.public_health": "Public Health",
    "1101_act.religious_studies": "Religious Studies",
    "1101_act.robotics_and_mechatronics": "Robotics and Mechatronics",
    "1101_act.social_and_community_work": "Social and Community Work",
    "1101_act.sociology": "Sociology",
    "1101_act.specialised_dance": "Specialised Dance",
    "1101_act.specialised_drama": "Specialised Drama",
    "1101_act.specialised_media": "Specialised Media",
    "1101_act.specialised_music": "Specialised Music",
    "1101_act.specialised_photography": "Specialised Photography",
    "1101_act.specialised_visual_arts": "Specialised Visual Arts",
    "1101_act.specialist_mathematics": "Specialist Mathematics",
    "1101_act.specialist_methods": "Specialist Methods",
    "1101_act.sport_fitness_and_recreation": "Sport, Fitness and Recreation",
    "1101_act.stage_performance": "Stage Performance",
    "1101_act.studies_of_dance": "Studies of Dance",
    "1101_act.studies_of_drama": "Studies of Drama",
    "1101_act.studies_of_media": "Studies of Media",
    "1101_act.studies_of_music": "Studies of Music",
    "1101_act.studies_of_photography": "Studies of Photography",
    "1101_act.studies_of_religion": "Studies of Religion",
    "1101_act.studies_of_visual_arts": "Studies of Visual Arts",
    "1101_act.timber_products": "Timber Products",
    "1101_act.tourism_and_event_management": "Tourism and Event Management",
    "1101_act.translating_and_interpreting": "Translating and Interpreting",
    "1101_act.uc_h_course_business_decision_making": "UC H Course Business Decision Making",
    "1101_act.uc_h_course_introduction_to_creative_writing": "UC H Course Introduction to Creative Writing",
    "1101_act.uc_h_course_meeting_environmental_challenges": "UC H Course Meeting Environmental Challenges",
    "1101_act.uc_h_course_performance_analysis_in_sport": "UC H Course Performance Analysis in Sport",
    "1101_act.uc_h_course_politics_and_democracy": "UC H Course Politics and Democracy",
    "1101_act.uc_h_course_systemic_anatomy_and_physiology": "UC H Course Systemic Anatomy and Physiology",
    "1101_act.uc_h_course_understanding_people_and_behaviour": "UC H Course Understanding People and Behaviour",
    "1101_act.uc_h_course_visual_communication_theory_and_principles": "UC H Course Visual Communication Theory and Principles",
    "1101_act.unsw_h_course_cybersecurity": "UNSW H Course Cybersecurity",
    "1101_act.unsw_h_course_systems_architecture": "UNSW H Course Systems Architecture",
    "1101_act.visual_arts": "Visual Arts",
    "1101_act.world_religions": "World Religions",
    "1101_nsw.aboriginal_languages_cec": "Aboriginal Languages (CEC)",
    "1101_nsw.aboriginal_studies": "Aboriginal Studies",
    "1101_nsw.aboriginal_studies_life_skills": "Aboriginal Studies Life Skills",
    "1101_nsw.agriculture": "Agriculture",
    "1101_nsw.agriculture_life_skills": "Agriculture Life Skills",
    "1101_nsw.ancient_history": "Ancient History",
    "1101_nsw.ancient_history_life_skills": "Ancient History Life Skills",
    "1101_nsw.arabic_continuers": "Arabic Continuers",
    "1101_nsw.arabic_extension": "Arabic Extension",
    "1101_nsw.armenian_continuers": "Armenian Continuers",
    "1101_nsw.armenian_continuers_new_from_2024": "Armenian Continuers (New from 2024)",
    "1101_nsw.automotive_vet": "Automotive (VET)",
    "1101_nsw.biology": "Biology",
    "1101_nsw.business_and_economics_life_skills": "Business and Economics Life Skills",
    "1101_nsw.business_services_vet": "Business Services (VET)",
    "1101_nsw.business_studies": "Business Studies",
    "1101_nsw.ceramics_cec": "Ceramics (CEC)",
    "1101_nsw.chemical_world_science_life_skills": "Chemical World Science Life Skills",
    "1101_nsw.chemistry": "Chemistry",
    "1101_nsw.chinese_and_literature": "Chinese and Literature",
    "1101_nsw.chinese_beginners": "Chinese Beginners",
    "1101_nsw.chinese_continuers": "Chinese Continuers",
    "1101_nsw.chinese_extension": "Chinese Extension",
    "1101_nsw.chinese_in_context": "Chinese in Context",
    "1101_nsw.chinese_in_context_new_from_2024": "Chinese in Context (New from 2024)",
    "1101_nsw.citizenship_and_legal_studies_life_skills": "Citizenship and Legal Studies Life Skills",
    "1101_nsw.classical_greek_continuers": "Classical Greek Continuers",
    "1101_nsw.classical_greek_extension": "Classical Greek Extension",
    "1101_nsw.classical_hebrew_continuers": "Classical Hebrew Continuers",
    "1101_nsw.classical_hebrew_extension": "Classical Hebrew Extension",
    "1101_nsw.community_and_family_studies": "Community and Family Studies",
    "1101_nsw.community_and_family_studies_life_skills": "Community and Family Studies Life Skills",
    "1101_nsw.computing_applications_cec": "Computing Applications (CEC)",
    "1101_nsw.construction_vet": "Construction (VET)",
    "1101_nsw.creative_arts_life_skills": "Creative Arts Life Skills",
    "1101_nsw.croatian_continuers": "Croatian Continuers",
    "1101_nsw.croatian_continuers_new_from_2024": "Croatian Continuers (New from 2024)",
    "1101_nsw.dance": "Dance",
    "1101_nsw.dance_life_skills": "Dance Life Skills",
    "1101_nsw.design_and_technology": "Design and Technology",
    "1101_nsw.design_and_technology_life_skills": "Design and Technology Life Skills",
    "1101_nsw.drama": "Drama",
    "1101_nsw.drama_life_skills": "Drama Life Skills",
    "1101_nsw.dutch_continuers": "Dutch Continuers",
    "1101_nsw.dutch_continuers_new_from_2024": "Dutch Continuers (New from 2024)",
    "1101_nsw.earth_and_environmental_science": "Earth and Environmental Science",
    "1101_nsw.earth_and_space_science_life_skills": "Earth and Space Science Life Skills",
    "1101_nsw.economics": "Economics",
    "1101_nsw.electrotechnology_vet": "Electrotechnology (VET)",
    "1101_nsw.engineering_studies": "Engineering Studies",
    "1101_nsw.english_advanced": "English Advanced",
    "1101_nsw.english_eal_d": "English EAL/D",
    "1101_nsw.english_extension": "English Extension",
    "1101_nsw.english_life_skills": "English Life Skills",
    "1101_nsw.english_standard": "English Standard",
    "1101_nsw.english_studies": "English Studies",
    "1101_nsw.entertainment_industry_vet": "Entertainment Industry (VET)",
    "1101_nsw.exploring_early_childhood_cec": "Exploring Early Childhood (CEC)",
    "1101_nsw.filipino_continuers": "Filipino Continuers",
    "1101_nsw.filipino_continuers_new_from_2024": "Filipino Continuers (New from 2024)",
    "1101_nsw.financial_services_vet": "Financial Services (VET)",
    "1101_nsw.food_technology": "Food Technology",
    "1101_nsw.food_technology_life_skills": "Food Technology Life Skills",
    "1101_nsw.french_beginners": "French Beginners",
    "1101_nsw.french_continuers": "French Continuers",
    "1101_nsw.french_extension": "French Extension",
    "1101_nsw.geography": "Geography",
    "1101_nsw.geography_life_skills": "Geography Life Skills",
    "1101_nsw.german_beginners": "German Beginners",
    "1101_nsw.german_continuers": "German Continuers",
    "1101_nsw.german_extension": "German Extension",
    "1101_nsw.hindi_continuers": "Hindi Continuers",
    "1101_nsw.hindi_continuers_new_from_2024": "Hindi Continuers (New from 2024)",
    "1101_nsw.history_extension": "History Extension",
    "1101_nsw.hospitality_vet": "Hospitality (VET)",
    "1101_nsw.human_services_vet": "Human Services (VET)",
    "1101_nsw.human_society_and_its_environment_life_skills": "Human Society and Its Environment Life Skills",
    "1101_nsw.hungarian_continuers": "Hungarian Continuers",
    "1101_nsw.hungarian_continuers_new_from_2024": "Hungarian Continuers (New from 2024)",
    "1101_nsw.indonesian_and_literature": "Indonesian and Literature",
    "1101_nsw.indonesian_beginners": "Indonesian Beginners",
    "1101_nsw.indonesian_continuers": "Indonesian Continuers",
    "1101_nsw.indonesian_extension": "Indonesian Extension",
    "1101_nsw.industrial_technology": "Industrial Technology",
    "1101_nsw.industrial_technology_life_skills": "Industrial Technology Life Skills",
    "1101_nsw.information_and_digital_technology_vet": "Information and Digital Technology (VET)",
    "1101_nsw.information_processes_and_technology": "Information Processes and Technology",
    "1101_nsw.information_processes_and_technology_life_skills": "Information Processes and Technology Life Skills",
    "1101_nsw.investigating_science": "Investigating Science",
    "1101_nsw.investigating_science_life_skills": "Investigating Science Life Skills",
    "1101_nsw.italian_beginners": "Italian Beginners",
    "1101_nsw.italian_continuers": "Italian Continuers",
    "1101_nsw.italian_extension": "Italian Extension",
    "1101_nsw.japanese_beginners": "Japanese Beginners",
    "1101_nsw.japanese_continuers": "Japanese Continuers",
    "1101_nsw.japanese_extension": "Japanese Extension",
    "1101_nsw.japanese_in_context": "Japanese in Context",
    "1101_nsw.japanese_in_context_new_from_2024": "Japanese in Context (New from 2024)",
    "1101_nsw.khmer_continuers": "Khmer Continuers",
    "1101_nsw.khmer_continuers_new_from_2024": "Khmer Continuers (New from 2024)",
    "1101_nsw.korean_and_literature": "Korean and Literature",
    "1101_nsw.korean_beginners": "Korean Beginners",
    "1101_nsw.korean_continuers": "Korean Continuers",
    "1101_nsw.korean_in_context": "Korean in Context",
    "1101_nsw.korean_in_context_new_from_2024": "Korean in Context (New from 2024)",
    "1101_nsw.latin_continuers": "Latin Continuers",
    "1101_nsw.latin_extension": "Latin Extension",
    "1101_nsw.legal_studies": "Legal Studies",
    "1101_nsw.living_world_science_life_skills": "Living World Science Life Skills",
    "1101_nsw.macedonian_continuers": "Macedonian Continuers",
    "1101_nsw.macedonian_continuers_new_from_2024": "Macedonian Continuers (New from 2024)",
    "1101_nsw.marine_studies_cec": "Marine Studies (CEC)",
    "1101_nsw.mathematics_advanced": "Mathematics Advanced",
    "1101_nsw.mathematics_extension_1": "Mathematics Extension 1",
    "1101_nsw.mathematics_extension_2": "Mathematics Extension 2",
    "1101_nsw.mathematics_life_skills": "Mathematics Life Skills",
    "1101_nsw.mathematics_standard": "Mathematics Standard",
    "1101_nsw.modern_greek_beginners": "Modern Greek Beginners",
    "1101_nsw.modern_greek_continuers": "Modern Greek Continuers",
    "1101_nsw.modern_greek_extension": "Modern Greek Extension",
    "1101_nsw.modern_hebrew_continuers": "Modern Hebrew Continuers",
    "1101_nsw.modern_history": "Modern History",
    "1101_nsw.modern_history_life_skills": "Modern History Life Skills",
    "1101_nsw.music_1": "Music 1",
    "1101_nsw.music_2": "Music 2",
    "1101_nsw.music_extension": "Music Extension",
    "1101_nsw.music_life_skills": "Music Life Skills",
    "1101_nsw.numeracy_cec": "Numeracy (CEC)",
    "1101_nsw.persian_continuers": "Persian Continuers",
    "1101_nsw.persian_continuers_new_from_2024": "Persian Continuers (New from 2024)",
    "1101_nsw.personal_development_health_and_physical_education": "Personal Development, Health and Physical Education",
    "1101_nsw.personal_development_health_and_physical_education_life_skills": "Personal Development, Health and Physical Education Life Skills",
    "1101_nsw.photography_video_and_digital_imaging_cec": "Photography, Video and Digital Imaging (CEC)",
    "1101_nsw.physical_world_science_life_skills": "Physical World Science Life Skills",
    "1101_nsw.physics": "Physics",
    "1101_nsw.polish_continuers": "Polish Continuers",
    "1101_nsw.polish_continuers_new_from_2024": "Polish Continuers (New from 2024)",
    "1101_nsw.portuguese_continuers": "Portuguese Continuers",
    "1101_nsw.portuguese_continuers_new_from_2024": "Portuguese Continuers (New from 2024)",
    "1101_nsw.primary_industries_vet": "Primary Industries (VET)",
    "1101_nsw.punjabi_continuers": "Punjabi Continuers",
    "1101_nsw.punjabi_continuers_new_from_2024": "Punjabi Continuers (New from 2024)",
    "1101_nsw.retail_services_vet": "Retail Services (VET)",
    "1101_nsw.russian_continuers": "Russian Continuers",
    "1101_nsw.russian_continuers_new_from_2024": "Russian Continuers (New from 2024)",
    "1101_nsw.science_extension": "Science Extension",
    "1101_nsw.serbian_continuers": "Serbian Continuers",
    "1101_nsw.serbian_continuers_new_from_2024": "Serbian Continuers (New from 2024)",
    "1101_nsw.society_and_culture": "Society and Culture",
    "1101_nsw.society_and_culture_life_skills": "Society and Culture Life Skills",
    "1101_nsw.software_design_and_development": "Software Design and Development",
    "1101_nsw.spanish_beginners": "Spanish Beginners",
    "1101_nsw.spanish_continuers": "Spanish Continuers",
    "1101_nsw.spanish_extension": "Spanish Extension",
    "1101_nsw.sport_lifestyle_and_recreation_studies_cec": "Sport, Lifestyle and Recreation Studies (CEC)",
    "1101_nsw.studies_of_religion_i": "Studies of Religion I",
    "1101_nsw.studies_of_religion_i_life_skills": "Studies of Religion I Life Skills",
    "1101_nsw.studies_of_religion_ii": "Studies of Religion II",
    "1101_nsw.studies_of_religion_ii_life_skills": "Studies of Religion II Life Skills",
    "1101_nsw.swedish_continuers": "Swedish Continuers",
    "1101_nsw.swedish_continuers_new_from_2024": "Swedish Continuers (New from 2024)",
    "1101_nsw.tamil_continuers": "Tamil Continuers",
    "1101_nsw.tamil_continuers_new_from_2024": "Tamil Continuers (New from 2024)",
    "1101_nsw.technology_life_skills": "Technology Life Skills",
    "1101_nsw.textiles_and_design": "Textiles and Design",
    "1101_nsw.textiles_and_design_life_skills": "Textiles and Design Life Skills",
    "1101_nsw.tourism_travel_and_events_vet": "Tourism, Travel and Events (VET)",
    "1101_nsw.turkish_continuers": "Turkish Continuers",
    "1101_nsw.turkish_continuers_new_from_2024": "Turkish Continuers (New from 2024)",
    "1101_nsw.vietnamese_continuers": "Vietnamese Continuers",
    "1101_nsw.visual_arts": "Visual Arts",
    "1101_nsw.visual_arts_life_skills": "Visual Arts Life Skills",
    "1101_nsw.visual_design_cec": "Visual Design (CEC)",
    "1101_nsw.vocational_education_and_training_vet_board_endorsed_courses_in_stage_6": "Vocational Education and Training (VET) Board Endorsed courses in Stage 6",
    "1101_nsw.work_and_the_community_life_skills": "Work and the Community Life Skills",
    "1101_nsw.work_studies_cec": "Work Studies (CEC)",
    "1101_nt.aboriginal_studies": "Aboriginal Studies",
    "1101_nt.accounting": "Accounting",
    "1101_nt.activating_identities_and_futures": "Activating Identities and Futures",
    "1101_nt.activating_identities_and_futures_modified": "Activating Identities and Futures: Modified",
    "1101_nt.additional_language": "Additional Language",
    "1101_nt.agricultural_production": "Agricultural Production",
    "1101_nt.agricultural_systems": "Agricultural Systems",
    "1101_nt.agriculture": "Agriculture",
    "1101_nt.ancient_studies": "Ancient Studies",
    "1101_nt.arabic_continuers": "Arabic (continuers)",
    "1101_nt.armenian_continuers": "Armenian (continuers)",
    "1101_nt.arts_and_the_community": "Arts and the Community",
    "1101_nt.auslan_continuers": "Auslan (continuers)",
    "1101_nt.bengali_continuers": "Bengali (continuers)",
    "1101_nt.biology": "Biology",
    "1101_nt.bosnian_continuers": "Bosnian (continuers)",
    "1101_nt.business_innovation": "Business Innovation",
    "1101_nt.business_innovation_a_modified": "Business Innovation A: Modified",
    "1101_nt.business_innovation_b_modified": "Business Innovation B: Modified",
    "1101_nt.business_innovation_modified": "Business Innovation: Modified",
    "1101_nt.chemistry": "Chemistry",
    "1101_nt.child_studies": "Child Studies",
    "1101_nt.chin_hakha_continuers": "Chin Hakha (continuers)",
    "1101_nt.chinese_background_speakers": "Chinese (background speakers)",
    "1101_nt.chinese_beginners": "Chinese (beginners)",
    "1101_nt.chinese_continuers": "Chinese (continuers)",
    "1101_nt.communication_and_the_community": "Communication and the Community",
    "1101_nt.community_studies": "Community Studies",
    "1101_nt.creative_arts": "Creative Arts",
    "1101_nt.creative_arts_a_modified": "Creative Arts A: Modified",
    "1101_nt.creative_arts_b_modified": "Creative Arts B: Modified",
    "1101_nt.creative_arts_local_program": "Creative Arts: Local Program",
    "1101_nt.creative_arts_modified": "Creative Arts: Modified",
    "1101_nt.croatian_continuers": "Croatian (continuers)",
    "1101_nt.cross-disciplinary_studies": "Cross-disciplinary Studies",
    "1101_nt.cross-disciplinary_studies_a_modified": "Cross-disciplinary Studies A: Modified",
    "1101_nt.cross-disciplinary_studies_b_modified": "Cross-disciplinary Studies B: Modified",
    "1101_nt.cross-disciplinary_studies_local_program": "Cross-disciplinary Studies: Local Program",
    "1101_nt.cross-disciplinary_studies_modified": "Cross-disciplinary Studies: Modified",
    "1101_nt.dance": "Dance",
    "1101_nt.design_technology_and_engineering_a_modified": "Design, Technology and Engineering A: Modified",
    "1101_nt.design_technology_and_engineering_b_modified": "Design, Technology and Engineering B: Modified",
    "1101_nt.design_technology_and_engineering_modified": "Design, Technology and Engineering: Modified",
    "1101_nt.digital_communication_solutions": "Digital Communication Solutions",
    "1101_nt.digital_technologies": "Digital Technologies",
    "1101_nt.drama": "Drama",
    "1101_nt.dutch_continuers": "Dutch (continuers)",
    "1101_nt.earth_and_environmental_science": "Earth and Environmental Science",
    "1101_nt.economics": "Economics",
    "1101_nt.english": "English",
    "1101_nt.english_as_an_additional_language": "English as an Additional Language",
    "1101_nt.english_literary_studies": "English Literary Studies",
    "1101_nt.english_modified": "English: Modified",
    "1101_nt.essential_english": "Essential English",
    "1101_nt.essential_mathematics": "Essential Mathematics",
    "1101_nt.exploring_identities_and_futures": "Exploring Identities and Futures",
    "1101_nt.exploring_identities_and_futures_modified": "Exploring Identities and Futures: Modified",
    "1101_nt.filipino_continuers": "Filipino (continuers)",
    "1101_nt.first_language": "First Language",
    "1101_nt.food_and_hospitality": "Food and Hospitality",
    "1101_nt.foods_and_the_community": "Foods and the Community",
    "1101_nt.french_beginners": "French (beginners)",
    "1101_nt.french_continuers": "French (continuers)",
    "1101_nt.general_mathematics": "General Mathematics",
    "1101_nt.geography": "Geography",
    "1101_nt.german_beginners": "German (beginners)",
    "1101_nt.german_continuers": "German (continuers)",
    "1101_nt.health_and_wellbeing": "Health and Wellbeing",
    "1101_nt.health_and_wellbeing_a_modified": "Health and Wellbeing A: Modified",
    "1101_nt.health_and_wellbeing_b_modified": "Health and Wellbeing B: Modified",
    "1101_nt.health_and_wellbeing_modified": "Health and Wellbeing: Modified",
    "1101_nt.health_recreation_and_the_community": "Health, Recreation, and the Community",
    "1101_nt.hebrew_continuers": "Hebrew (continuers)",
    "1101_nt.hindi_continuers": "Hindi (continuers)",
    "1101_nt.humanities_and_social_sciences_connections": "Humanities and Social Sciences Connections",
    "1101_nt.hungarian_continuers": "Hungarian (continuers)",
    "1101_nt.indonesian_background_speakers": "Indonesian (background speakers)",
    "1101_nt.indonesian_beginners": "Indonesian (beginners)",
    "1101_nt.indonesian_continuers": "Indonesian (continuers)",
    "1101_nt.industry_and_entrepreneurial_solutions": "Industry and Entrepreneurial Solutions",
    "1101_nt.industry_connections_a": "Industry Connections A",
    "1101_nt.industry_connections_b": "Industry Connections B",
    "1101_nt.industry_connections_c": "Industry Connections C",
    "1101_nt.information_processing_and_publishing": "Information Processing and Publishing",
    "1101_nt.integrated_learning": "Integrated Learning",
    "1101_nt.integrated_learning_a": "Integrated Learning A",
    "1101_nt.integrated_learning_b": "Integrated Learning B",
    "1101_nt.interdisciplinary_connections": "Interdisciplinary Connections",
    "1101_nt.italian_beginners": "Italian (beginners)",
    "1101_nt.italian_continuers": "Italian (continuers)",
    "1101_nt.japanese_background_speakers": "Japanese (background speakers)",
    "1101_nt.japanese_beginners": "Japanese (beginners)",
    "1101_nt.japanese_continuers": "Japanese (continuers)",
    "1101_nt.karen_continuers": "Karen (continuers)",
    "1101_nt.khmer_continuers": "Khmer (continuers)",
    "1101_nt.korean_background_speakers": "Korean (background speakers)",
    "1101_nt.korean_beginners": "Korean (beginners)",
    "1101_nt.korean_continuers": "Korean (continuers)",
    "1101_nt.language_and_culture": "Language and Culture",
    "1101_nt.language_and_culture_a_modified": "Language and Culture A: Modified",
    "1101_nt.language_and_culture_b_modified": "Language and Culture B: Modified",
    "1101_nt.language_and_culture_local_program": "Language and Culture: Local Program",
    "1101_nt.language_and_culture_modified": "Language and Culture: Modified",
    "1101_nt.latin_continuers": "Latin (continuers)",
    "1101_nt.legal_studies": "Legal Studies",
    "1101_nt.macedonian_continuers": "Macedonian (continuers)",
    "1101_nt.material_solutions": "Material Solutions",
    "1101_nt.mathematical_methods": "Mathematical Methods",
    "1101_nt.mathematics": "Mathematics",
    "1101_nt.mathematics_modified": "Mathematics: Modified",
    "1101_nt.media_studies": "Media Studies",
    "1101_nt.modern_greek_beginners": "Modern Greek (beginners)",
    "1101_nt.modern_greek_continuers": "Modern Greek (continuers)",
    "1101_nt.modern_history": "Modern History",
    "1101_nt.music_advanced": "Music Advanced",
    "1101_nt.music_experience": "Music Experience",
    "1101_nt.music_explorations": "Music Explorations",
    "1101_nt.music_performance_ensemble": "Music Performance – Ensemble",
    "1101_nt.music_performance_solo": "Music Performance – Solo",
    "1101_nt.music_studies": "Music Studies",
    "1101_nt.nepali_continuers": "Nepali (continuers)",
    "1101_nt.nutrition": "Nutrition",
    "1101_nt.outdoor_education": "Outdoor Education",
    "1101_nt.persian_continuers": "Persian (continuers)",
    "1101_nt.philosophy": "Philosophy",
    "1101_nt.physical_education": "Physical Education",
    "1101_nt.physical_education_a_modified": "Physical Education A: Modified",
    "1101_nt.physical_education_b_modified": "Physical Education B: Modified",
    "1101_nt.physical_education_modified": "Physical Education: Modified",
    "1101_nt.physics": "Physics",
    "1101_nt.polish_continuers": "Polish (continuers)",
    "1101_nt.politics_power_and_people": "Politics, Power and People",
    "1101_nt.portuguese_continuers": "Portuguese (continuers)",
    "1101_nt.practical_connections": "Practical Connections",
    "1101_nt.psychology": "Psychology",
    "1101_nt.punjabi_continuers": "Punjabi (continuers)",
    "1101_nt.research_practices": "Research Practices",
    "1101_nt.revival_language": "Revival Language",
    "1101_nt.robotic_and_electronic_systems": "Robotic and Electronic Systems",
    "1101_nt.romanian_continuers": "Romanian (continuers)",
    "1101_nt.russian_continuers": "Russian (continuers)",
    "1101_nt.science_technology_and_the_community": "Science, Technology, and the Community",
    "1101_nt.scientific_studies": "Scientific Studies",
    "1101_nt.scientific_studies_a_modified": "Scientific Studies A: Modified",
    "1101_nt.scientific_studies_b_modified": "Scientific Studies B: Modified",
    "1101_nt.scientific_studies_modified": "Scientific Studies: Modified",
    "1101_nt.serbian_continuers": "Serbian (continuers)",
    "1101_nt.sinhala_continuers": "Sinhala (continuers)",
    "1101_nt.society_and_culture": "Society and Culture",
    "1101_nt.society_and_culture_a_modified": "Society and Culture A: Modified",
    "1101_nt.society_and_culture_b_modified": "Society and Culture B: Modified",
    "1101_nt.society_and_culture_local_program": "Society and Culture: Local Program",
    "1101_nt.society_and_culture_modified": "Society and Culture: Modified",
    "1101_nt.spanish_beginners": "Spanish (beginners)",
    "1101_nt.spanish_continuers": "Spanish (continuers)",
    "1101_nt.specialist_mathematics": "Specialist Mathematics",
    "1101_nt.spiritualities_religion_and_meaning": "Spiritualities, Religion and Meaning",
    "1101_nt.stem_connections": "STEM Connections",
    "1101_nt.swedish_continuers": "Swedish (continuers)",
    "1101_nt.tamil_continuers": "Tamil (continuers)",
    "1101_nt.tourism": "Tourism",
    "1101_nt.turkish_continuers": "Turkish (continuers)",
    "1101_nt.vietnamese_background_speakers": "Vietnamese (background speakers)",
    "1101_nt.vietnamese_continuers": "Vietnamese (continuers)",
    "1101_nt.visual_arts_art": "Visual Arts — Art",
    "1101_nt.visual_arts_design": "Visual Arts — Design",
    "1101_nt.women_s_studies": "Women’s Studies",
    "1101_nt.work_and_the_community": "Work and the Community",
    "1101_nt.workplace_practices": "Workplace Practices",
    "1101_nt.workplace_practices_a": "Workplace Practices A",
    "1101_nt.workplace_practices_b": "Workplace Practices B",
    "1101_qld.aboriginal_torres_strait_islander_languages": "Aboriginal & Torres Strait Islander Languages",
    "1101_qld.aboriginal_torres_strait_islander_studies": "Aboriginal & Torres Strait Islander Studies",
    "1101_qld.accounting": "Accounting",
    "1101_qld.aerospace_systems": "Aerospace Systems",
    "1101_qld.agricultural_practices": "Agricultural Practices",
    "1101_qld.agricultural_science": "Agricultural Science",
    "1101_qld.agricultural_science_as": "Agricultural Science AS",
    "1101_qld.ancient_history": "Ancient History",
    "1101_qld.aquatic_practices": "Aquatic Practices",
    "1101_qld.arts_in_practice": "Arts in Practice",
    "1101_qld.biology": "Biology",
    "1101_qld.building_construction_skills": "Building & Construction Skills",
    "1101_qld.business": "Business",
    "1101_qld.business_studies": "Business Studies",
    "1101_qld.career_education": "Career Education",
    "1101_qld.chemistry": "Chemistry",
    "1101_qld.chinese": "Chinese",
    "1101_qld.chinese_extension": "Chinese Extension",
    "1101_qld.dance": "Dance",
    "1101_qld.dance_in_practice": "Dance in Practice",
    "1101_qld.design": "Design",
    "1101_qld.digital_solutions": "Digital Solutions",
    "1101_qld.drama": "Drama",
    "1101_qld.drama_in_practice": "Drama in Practice",
    "1101_qld.early_childhood_studies": "Early Childhood Studies",
    "1101_qld.earth_environmental_science": "Earth & Environmental Science",
    "1101_qld.economics": "Economics",
    "1101_qld.engineering": "Engineering",
    "1101_qld.engineering_skills": "Engineering Skills",
    "1101_qld.english": "English",
    "1101_qld.english_as_an_additional_language": "English as an Additional Language",
    "1101_qld.english_literature_extension": "English & Literature Extension",
    "1101_qld.essential_english": "Essential English",
    "1101_qld.essential_mathematics": "Essential Mathematics",
    "1101_qld.fashion": "Fashion",
    "1101_qld.film_television_new_media": "Film, Television & New Media",
    "1101_qld.food_nutrition": "Food & Nutrition",
    "1101_qld.french": "French",
    "1101_qld.french_extension": "French Extension",
    "1101_qld.furnishing_skills": "Furnishing Skills",
    "1101_qld.general_mathematics": "General Mathematics",
    "1101_qld.geography": "Geography",
    "1101_qld.german": "German",
    "1101_qld.german_extension": "German Extension",
    "1101_qld.health": "Health",
    "1101_qld.hospitality_practices": "Hospitality Practices",
    "1101_qld.industrial_graphics_skills": "Industrial Graphics Skills",
    "1101_qld.industrial_technology_skills": "Industrial Technology Skills",
    "1101_qld.information_communication_technology": "Information & Communication Technology",
    "1101_qld.italian": "Italian",
    "1101_qld.japanese": "Japanese",
    "1101_qld.legal_studies": "Legal Studies",
    "1101_qld.literacy": "Literacy",
    "1101_qld.literature": "Literature",
    "1101_qld.marine_science": "Marine Science",
    "1101_qld.mathematical_methods": "Mathematical Methods",
    "1101_qld.media_arts_in_practice": "Media Arts in Practice",
    "1101_qld.modern_history": "Modern History",
    "1101_qld.music": "Music",
    "1101_qld.music_extension_composition": "Music Extension (Composition)",
    "1101_qld.music_extension_musicology": "Music Extension (Musicology)",
    "1101_qld.music_extension_performance": "Music Extension (Performance)",
    "1101_qld.music_in_practice": "Music in Practice",
    "1101_qld.numeracy": "Numeracy",
    "1101_qld.philosophy_reason": "Philosophy & Reason",
    "1101_qld.physical_education": "Physical Education",
    "1101_qld.physics": "Physics",
    "1101_qld.psychology": "Psychology",
    "1101_qld.religion_ethics": "Religion & Ethics",
    "1101_qld.science_in_practice": "Science in Practice",
    "1101_qld.social_community_studies": "Social & Community Studies",
    "1101_qld.spanish": "Spanish",
    "1101_qld.specialist_mathematics": "Specialist Mathematics",
    "1101_qld.sport_recreation": "Sport & Recreation",
    "1101_qld.study_of_religion": "Study of Religion",
    "1101_qld.tourism": "Tourism",
    "1101_qld.visual_art": "Visual Art",
    "1101_qld.visual_arts_in_practice": "Visual Arts in Practice",
    "1101_sa.aboriginal_studies": "Aboriginal Studies",
    "1101_sa.accounting": "Accounting",
    "1101_sa.activating_identities_and_futures": "Activating Identities and Futures",
    "1101_sa.activating_identities_and_futures_modified": "Activating Identities and Futures: Modified",
    "1101_sa.additional_language": "Additional Language",
    "1101_sa.agricultural_production": "Agricultural Production",
    "1101_sa.agricultural_systems": "Agricultural Systems",
    "1101_sa.agriculture": "Agriculture",
    "1101_sa.ancient_studies": "Ancient Studies",
    "1101_sa.arabic_continuers": "Arabic (continuers)",
    "1101_sa.armenian_continuers": "Armenian (continuers)",
    "1101_sa.arts_and_the_community": "Arts and the Community",
    "1101_sa.auslan_continuers": "Auslan (continuers)",
    "1101_sa.bengali_continuers": "Bengali (continuers)",
    "1101_sa.biology": "Biology",
    "1101_sa.bosnian_continuers": "Bosnian (continuers)",
    "1101_sa.business_innovation": "Business Innovation",
    "1101_sa.business_innovation_a_modified": "Business Innovation A: Modified",
    "1101_sa.business_innovation_b_modified": "Business Innovation B: Modified",
    "1101_sa.business_innovation_modified": "Business Innovation: Modified",
    "1101_sa.chemistry": "Chemistry",
    "1101_sa.child_studies": "Child Studies",
    "1101_sa.chin_hakha_continuers": "Chin Hakha (continuers)",
    "1101_sa.chinese_background_speakers": "Chinese (background speakers)",
    "1101_sa.chinese_beginners": "Chinese (beginners)",
    "1101_sa.chinese_continuers": "Chinese (continuers)",
    "1101_sa.communication_and_the_community": "Communication and the Community",
    "1101_sa.community_studies": "Community Studies",
    "1101_sa.creative_arts": "Creative Arts",
    "1101_sa.creative_arts_a_modified": "Creative Arts A: Modified",
    "1101_sa.creative_arts_b_modified": "Creative Arts B: Modified",
    "1101_sa.creative_arts_local_program": "Creative Arts: Local Program",
    "1101_sa.creative_arts_modified": "Creative Arts: Modified",
    "1101_sa.croatian_continuers": "Croatian (continuers)",
    "1101_sa.cross-disciplinary_studies": "Cross-disciplinary Studies",
    "1101_sa.cross-disciplinary_studies_a_modified": "Cross-disciplinary Studies A: Modified",
    "1101_sa.cross-disciplinary_studies_b_modified": "Cross-disciplinary Studies B: Modified",
    "1101_sa.cross-disciplinary_studies_local_program": "Cross-disciplinary Studies: Local Program",
    "1101_sa.cross-disciplinary_studies_modified": "Cross-disciplinary Studies: Modified",
    "1101_sa.dance": "Dance",
    "1101_sa.design_technology_and_engineering_a_modified": "Design, Technology and Engineering A: Modified",
    "1101_sa.design_technology_and_engineering_b_modified": "Design, Technology and Engineering B: Modified",
    "1101_sa.design_technology_and_engineering_modified": "Design, Technology and Engineering: Modified",
    "1101_sa.digital_communication_solutions": "Digital Communication Solutions",
    "1101_sa.digital_technologies": "Digital Technologies",
    "1101_sa.drama": "Drama",
    "1101_sa.dutch_continuers": "Dutch (continuers)",
    "1101_sa.earth_and_environmental_science": "Earth and Environmental Science",
    "1101_sa.economics": "Economics",
    "1101_sa.english": "English",
    "1101_sa.english_as_an_additional_language": "English as an Additional Language",
    "1101_sa.english_literary_studies": "English Literary Studies",
    "1101_sa.english_modified": "English: Modified",
    "1101_sa.essential_english": "Essential English",
    "1101_sa.essential_mathematics": "Essential Mathematics",
    "1101_sa.exploring_identities_and_futures": "Exploring Identities and Futures",
    "1101_sa.exploring_identities_and_futures_modified": "Exploring Identities and Futures: Modified",
    "1101_sa.filipino_continuers": "Filipino (continuers)",
    "1101_sa.first_language": "First Language",
    "1101_sa.food_and_hospitality": "Food and Hospitality",
    "1101_sa.foods_and_the_community": "Foods and the Community",
    "1101_sa.french_beginners": "French (beginners)",
    "1101_sa.french_continuers": "French (continuers)",
    "1101_sa.general_mathematics": "General Mathematics",
    "1101_sa.geography": "Geography",
    "1101_sa.german_beginners": "German (beginners)",
    "1101_sa.german_continuers": "German (continuers)",
    "1101_sa.health_and_wellbeing": "Health and Wellbeing",
    "1101_sa.health_and_wellbeing_a_modified": "Health and Wellbeing A: Modified",
    "1101_sa.health_and_wellbeing_b_modified": "Health and Wellbeing B: Modified",
    "1101_sa.health_and_wellbeing_modified": "Health and Wellbeing: Modified",
    "1101_sa.health_recreation_and_the_community": "Health, Recreation, and the Community",
    "1101_sa.hebrew_continuers": "Hebrew (continuers)",
    "1101_sa.hindi_continuers": "Hindi (continuers)",
    "1101_sa.humanities_and_social_sciences_connections": "Humanities and Social Sciences Connections",
    "1101_sa.hungarian_continuers": "Hungarian (continuers)",
    "1101_sa.indonesian_background_speakers": "Indonesian (background speakers)",
    "1101_sa.indonesian_beginners": "Indonesian (beginners)",
    "1101_sa.indonesian_continuers": "Indonesian (continuers)",
    "1101_sa.industry_and_entrepreneurial_solutions": "Industry and Entrepreneurial Solutions",
    "1101_sa.industry_connections_a": "Industry Connections A",
    "1101_sa.industry_connections_b": "Industry Connections B",
    "1101_sa.industry_connections_c": "Industry Connections C",
    "1101_sa.information_processing_and_publishing": "Information Processing and Publishing",
    "1101_sa.integrated_learning": "Integrated Learning",
    "1101_sa.integrated_learning_a": "Integrated Learning A",
    "1101_sa.integrated_learning_b": "Integrated Learning B",
    "1101_sa.interdisciplinary_connections": "Interdisciplinary Connections",
    "1101_sa.italian_beginners": "Italian (beginners)",
    "1101_sa.italian_continuers": "Italian (continuers)",
    "1101_sa.japanese_background_speakers": "Japanese (background speakers)",
    "1101_sa.japanese_beginners": "Japanese (beginners)",
    "1101_sa.japanese_continuers": "Japanese (continuers)",
    "1101_sa.karen_continuers": "Karen (continuers)",
    "1101_sa.khmer_continuers": "Khmer (continuers)",
    "1101_sa.korean_background_speakers": "Korean (background speakers)",
    "1101_sa.korean_beginners": "Korean (beginners)",
    "1101_sa.korean_continuers": "Korean (continuers)",
    "1101_sa.language_and_culture": "Language and Culture",
    "1101_sa.language_and_culture_a_modified": "Language and Culture A: Modified",
    "1101_sa.language_and_culture_b_modified": "Language and Culture B: Modified",
    "1101_sa.language_and_culture_local_program": "Language and Culture: Local Program",
    "1101_sa.language_and_culture_modified": "Language and Culture: Modified",
    "1101_sa.latin_continuers": "Latin (continuers)",
    "1101_sa.legal_studies": "Legal Studies",
    "1101_sa.macedonian_continuers": "Macedonian (continuers)",
    "1101_sa.material_solutions": "Material Solutions",
    "1101_sa.mathematical_methods": "Mathematical Methods",
    "1101_sa.mathematics": "Mathematics",
    "1101_sa.mathematics_modified": "Mathematics: Modified",
    "1101_sa.media_studies": "Media Studies",
    "1101_sa.modern_greek_beginners": "Modern Greek (beginners)",
    "1101_sa.modern_greek_continuers": "Modern Greek (continuers)",
    "1101_sa.modern_history": "Modern History",
    "1101_sa.music_advanced": "Music Advanced",
    "1101_sa.music_experience": "Music Experience",
    "1101_sa.music_explorations": "Music Explorations",
    "1101_sa.music_performance_ensemble": "Music Performance – Ensemble",
    "1101_sa.music_performance_solo": "Music Performance – Solo",
    "1101_sa.music_studies": "Music Studies",
    "1101_sa.nepali_continuers": "Nepali (continuers)",
    "1101_sa.nutrition": "Nutrition",
    "1101_sa.outdoor_education": "Outdoor Education",
    "1101_sa.persian_continuers": "Persian (continuers)",
    "1101_sa.philosophy": "Philosophy",
    "1101_sa.physical_education": "Physical Education",
    "1101_sa.physical_education_a_modified": "Physical Education A: Modified",
    "1101_sa.physical_education_b_modified": "Physical Education B: Modified",
    "1101_sa.physical_education_modified": "Physical Education: Modified",
    "1101_sa.physics": "Physics",
    "1101_sa.polish_continuers": "Polish (continuers)",
    "1101_sa.politics_power_and_people": "Politics, Power and People",
    "1101_sa.portuguese_continuers": "Portuguese (continuers)",
    "1101_sa.practical_connections": "Practical Connections",
    "1101_sa.psychology": "Psychology",
    "1101_sa.punjabi_continuers": "Punjabi (continuers)",
    "1101_sa.research_practices": "Research Practices",
    "1101_sa.revival_language": "Revival Language",
    "1101_sa.robotic_and_electronic_systems": "Robotic and Electronic Systems",
    "1101_sa.romanian_continuers": "Romanian (continuers)",
    "1101_sa.russian_continuers": "Russian (continuers)",
    "1101_sa.science_technology_and_the_community": "Science, Technology, and the Community",
    "1101_sa.scientific_studies": "Scientific Studies",
    "1101_sa.scientific_studies_a_modified": "Scientific Studies A: Modified",
    "1101_sa.scientific_studies_b_modified": "Scientific Studies B: Modified",
    "1101_sa.scientific_studies_modified": "Scientific Studies: Modified",
    "1101_sa.serbian_continuers": "Serbian (continuers)",
    "1101_sa.sinhala_continuers": "Sinhala (continuers)",
    "1101_sa.society_and_culture": "Society and Culture",
    "1101_sa.society_and_culture_a_modified": "Society and Culture A: Modified",
    "1101_sa.society_and_culture_b_modified": "Society and Culture B: Modified",
    "1101_sa.society_and_culture_local_program": "Society and Culture: Local Program",
    "1101_sa.society_and_culture_modified": "Society and Culture: Modified",
    "1101_sa.spanish_beginners": "Spanish (beginners)",
    "1101_sa.spanish_continuers": "Spanish (continuers)",
    "1101_sa.specialist_mathematics": "Specialist Mathematics",
    "1101_sa.spiritualities_religion_and_meaning": "Spiritualities, Religion and Meaning",
    "1101_sa.stem_connections": "STEM Connections",
    "1101_sa.swedish_continuers": "Swedish (continuers)",
    "1101_sa.tamil_continuers": "Tamil (continuers)",
    "1101_sa.tourism": "Tourism",
    "1101_sa.turkish_continuers": "Turkish (continuers)",
    "1101_sa.vietnamese_background_speakers": "Vietnamese (background speakers)",
    "1101_sa.vietnamese_continuers": "Vietnamese (continuers)",
    "1101_sa.visual_arts_art": "Visual Arts — Art",
    "1101_sa.visual_arts_design": "Visual Arts — Design",
    "1101_sa.women_s_studies": "Women’s Studies",
    "1101_sa.work_and_the_community": "Work and the Community",
    "1101_sa.workplace_practices": "Workplace Practices",
    "1101_sa.workplace_practices_a": "Workplace Practices A",
    "1101_sa.workplace_practices_b": "Workplace Practices B",
    "1101_tas.accounting": "Accounting",
    "1101_tas.agricultural_enterprise": "Agricultural Enterprise",
    "1101_tas.agricultural_systems": "Agricultural Systems",
    "1101_tas.ancient_history": "Ancient History",
    "1101_tas.art_studio_practice": "Art Studio Practice",
    "1101_tas.arts": "Arts",
    "1101_tas.athlete_development": "Athlete Development",
    "1101_tas.australia_in_asia_and_the_pacific": "Australia in Asia and the Pacific",
    "1101_tas.automotive_and_mechanical_technologies": "Automotive and Mechanical Technologies",
    "1101_tas.basic_road_safety": "Basic Road Safety",
    "1101_tas.biology": "Biology",
    "1101_tas.building_connections": "Building Connections",
    "1101_tas.business_studies": "Business Studies",
    "1101_tas.business_studies_-_foundation": "Business Studies - Foundation",
    "1101_tas.career_and_life_planning": "Career and Life Planning",
    "1101_tas.chemistry": "Chemistry",
    "1101_tas.chinese": "Chinese",
    "1101_tas.civics_and_citizenship": "Civics and Citizenship",
    "1101_tas.community_service_learning": "Community Service Learning",
    "1101_tas.community_sport_and_recreation": "Community Sport and Recreation",
    "1101_tas.computer_applications": "Computer Applications",
    "1101_tas.computer_graphics_and_design": "Computer Graphics and Design",
    "1101_tas.computer_graphics_and_design_-_foundation": "Computer Graphics and Design - Foundation",
    "1101_tas.computer_science": "Computer Science",
    "1101_tas.contemporary_art_practice": "Contemporary Art Practice",
    "1101_tas.contemporary_music_and_songwriting": "Contemporary Music and Songwriting",
    "1101_tas.dance": "Dance",
    "1101_tas.data_science_and_digital_solutions": "Data Science and Digital Solutions",
    "1101_tas.design_and_production": "Design and Production",
    "1101_tas.digital_projects": "Digital Projects",
    "1101_tas.digital_technologies": "Digital Technologies",
    "1101_tas.drama": "Drama",
    "1101_tas.drama_foundations": "Drama Foundations",
    "1101_tas.economics": "Economics",
    "1101_tas.electronics_and_advanced_technologies": "Electronics and Advanced Technologies",
    "1101_tas.engineering_design": "Engineering Design",
    "1101_tas.english": "English",
    "1101_tas.english_as_an_additional_language_or_dialect": "English as an Additional Language or Dialect",
    "1101_tas.english_foundations": "English Foundations",
    "1101_tas.english_inquiry": "English Inquiry",
    "1101_tas.english_literature": "English Literature",
    "1101_tas.english_studio": "English Studio",
    "1101_tas.enterprise_at_work": "Enterprise at Work",
    "1101_tas.environmental_science": "Environmental Science",
    "1101_tas.essential_mathematics_-_personal": "Essential Mathematics - Personal",
    "1101_tas.essential_mathematics_-_workplace": "Essential Mathematics - Workplace",
    "1101_tas.essential_skills_-_maths": "Essential Skills - Maths",
    "1101_tas.essential_skills_-_reading_and_writing": "Essential Skills - Reading and Writing",
    "1101_tas.essential_skills_-_using_computers_and_the_internet": "Essential Skills - Using Computers and the Internet",
    "1101_tas.exploring_issues_in_society": "Exploring Issues in Society",
    "1101_tas.financial_literacy": "Financial Literacy",
    "1101_tas.first_nations_studies": "First Nations Studies",
    "1101_tas.fitness_experiences": "Fitness Experiences",
    "1101_tas.focus_on_children": "Focus on Children",
    "1101_tas.food_and_cooking_essentials": "Food and Cooking Essentials",
    "1101_tas.food_and_hospitality_enterprise": "Food and Hospitality Enterprise",
    "1101_tas.food_and_nutrition": "Food and Nutrition",
    "1101_tas.food_cooking_and_nutrition": "Food, Cooking and Nutrition",
    "1101_tas.french": "French",
    "1101_tas.general_mathematics": "General Mathematics",
    "1101_tas.geography": "Geography",
    "1101_tas.german": "German",
    "1101_tas.health_studies": "Health Studies",
    "1101_tas.history": "History",
    "1101_tas.housing_and_design": "Housing and Design",
    "1101_tas.introduction_to_sociology_and_psychology": "Introduction to Sociology and Psychology",
    "1101_tas.italian": "Italian",
    "1101_tas.japanese": "Japanese",
    "1101_tas.learning_through_internship": "Learning Through Internship",
    "1101_tas.legal_studies": "Legal Studies",
    "1101_tas.legal_studies_-_foundation": "Legal Studies - Foundation",
    "1101_tas.making_moral_decisions": "Making Moral Decisions",
    "1101_tas.mathematics": "Mathematics",
    "1101_tas.mathematics_methods": "Mathematics Methods",
    "1101_tas.mathematics_methods_-_foundation": "Mathematics Methods - Foundation",
    "1101_tas.mathematics_specialised": "Mathematics Specialised",
    "1101_tas.media_production": "Media Production",
    "1101_tas.media_production_foundations": "Media Production Foundations",
    "1101_tas.modern_history": "Modern History",
    "1101_tas.music": "Music",
    "1101_tas.music_ensemble": "Music Ensemble",
    "1101_tas.music_studies": "Music Studies",
    "1101_tas.music_technology_projects_-_foundation": "Music Technology Projects - Foundation",
    "1101_tas.musical_theatre": "Musical Theatre",
    "1101_tas.numeracy": "Numeracy",
    "1101_tas.outdoor_education": "Outdoor Education",
    "1101_tas.outdoor_experiences": "Outdoor Experiences",
    "1101_tas.outdoor_leadership": "Outdoor Leadership",
    "1101_tas.pathways_to_work": "Pathways to Work",
    "1101_tas.personal_care": "Personal Care",
    "1101_tas.personal_health_and_wellbeing": "Personal Health and Wellbeing",
    "1101_tas.philosophy": "Philosophy",
    "1101_tas.physical_sciences": "Physical Sciences",
    "1101_tas.physical_sciences_-_foundation": "Physical Sciences - Foundation",
    "1101_tas.physics": "Physics",
    "1101_tas.preliminary_access_to_work_stage_1": "Preliminary Access to Work Stage 1",
    "1101_tas.preliminary_access_to_work_stage_2": "Preliminary Access to Work Stage 2",
    "1101_tas.preliminary_access_to_work_stage_3": "Preliminary Access to Work Stage 3",
    "1101_tas.preliminary_access_to_work_stage_4": "Preliminary Access to Work Stage 4",
    "1101_tas.preliminary_arts_stage_1": "Preliminary Arts Stage 1",
    "1101_tas.preliminary_arts_stage_2": "Preliminary Arts Stage 2",
    "1101_tas.preliminary_arts_stage_3": "Preliminary Arts Stage 3",
    "1101_tas.preliminary_arts_stage_4": "Preliminary Arts Stage 4",
    "1101_tas.preliminary_english_stage_1": "Preliminary English Stage 1",
    "1101_tas.preliminary_english_stage_2": "Preliminary English Stage 2",
    "1101_tas.preliminary_english_stage_3": "Preliminary English Stage 3",
    "1101_tas.preliminary_english_stage_4": "Preliminary English Stage 4",
    "1101_tas.preliminary_health_and_physical_education_stage_1": "Preliminary Health and Physical Education Stage 1",
    "1101_tas.preliminary_health_and_physical_education_stage_2": "Preliminary Health and Physical Education Stage 2",
    "1101_tas.preliminary_health_and_physical_education_stage_3": "Preliminary Health and Physical Education Stage 3",
    "1101_tas.preliminary_health_and_physical_education_stage_4": "Preliminary Health and Physical Education Stage 4",
    "1101_tas.preliminary_humanities_stage_1": "Preliminary Humanities Stage 1",
    "1101_tas.preliminary_humanities_stage_2": "Preliminary Humanities Stage 2",
    "1101_tas.preliminary_humanities_stage_3": "Preliminary Humanities Stage 3",
    "1101_tas.preliminary_humanities_stage_4": "Preliminary Humanities Stage 4",
    "1101_tas.preliminary_mathematics_stage_1": "Preliminary Mathematics Stage 1",
    "1101_tas.preliminary_mathematics_stage_2": "Preliminary Mathematics Stage 2",
    "1101_tas.preliminary_mathematics_stage_3": "Preliminary Mathematics Stage 3",
    "1101_tas.preliminary_mathematics_stage_4": "Preliminary Mathematics Stage 4",
    "1101_tas.preliminary_science_stage_1": "Preliminary Science Stage 1",
    "1101_tas.preliminary_science_stage_2": "Preliminary Science Stage 2",
    "1101_tas.preliminary_science_stage_3": "Preliminary Science Stage 3",
    "1101_tas.preliminary_science_stage_4": "Preliminary Science Stage 4",
    "1101_tas.preliminary_technologies_stage_1": "Preliminary Technologies Stage 1",
    "1101_tas.preliminary_technologies_stage_2": "Preliminary Technologies Stage 2",
    "1101_tas.preliminary_technologies_stage_3": "Preliminary Technologies Stage 3",
    "1101_tas.preliminary_technologies_stage_4": "Preliminary Technologies Stage 4",
    "1101_tas.project_implementation": "Project Implementation",
    "1101_tas.psychology": "Psychology",
    "1101_tas.road_safety_education": "Road Safety Education",
    "1101_tas.science": "Science",
    "1101_tas.sociology": "Sociology",
    "1101_tas.sport_and_recreation_experiences": "Sport and Recreation Experiences",
    "1101_tas.sport_science": "Sport Science",
    "1101_tas.sport_science_-_foundation": "Sport Science - Foundation",
    "1101_tas.student_directed_inquiry": "Student Directed Inquiry",
    "1101_tas.studies_of_religion": "Studies of Religion",
    "1101_tas.tasmanian_aboriginal_studies": "Tasmanian Aboriginal Studies",
    "1101_tas.technical_theatre_production": "Technical Theatre Production",
    "1101_tas.theatre_performance": "Theatre Performance",
    "1101_tas.transdisciplinary_science": "Transdisciplinary Science",
    "1101_tas.visual_art": "Visual Art",
    "1101_tas.work_readiness": "Work Readiness",
    "1101_tas.working_with_children": "Working with Children",
    "1101_tas.workshop_techniques_-_introduction": "Workshop Techniques - Introduction",
    "1101_tas.you_your_family_and_the_community": "You, Your Family and the Community",
    "1101_vic.accounting": "Accounting",
    "1101_vic.algorithmics_hess": "Algorithmics (HESS)",
    "1101_vic.applied_computing": "Applied Computing",
    "1101_vic.arabic": "Arabic",
    "1101_vic.armenian": "Armenian",
    "1101_vic.art": "Art",
    "1101_vic.auslan": "Auslan",
    "1101_vic.australian_and_global_politics": "Australian and Global Politics",
    "1101_vic.bengali": "Bengali",
    "1101_vic.bosnian": "Bosnian",
    "1101_vic.business_management": "Business Management",
    "1101_vic.chemistry": "Chemistry",
    "1101_vic.chin_hakha": "Chin Hakha",
    "1101_vic.chinese_first_language": "Chinese First Language",
    "1101_vic.chinese_language_culture_and_society": "Chinese Language, Culture and Society",
    "1101_vic.chinese_second_language": "Chinese Second Language",
    "1101_vic.chinese_second_language_advanced": "Chinese Second Language Advanced",
    "1101_vic.classical_greek": "Classical Greek",
    "1101_vic.classical_hebrew": "Classical Hebrew",
    "1101_vic.classical_studies": "Classical Studies",
    "1101_vic.croatian": "Croatian",
    "1101_vic.drama": "Drama",
    "1101_vic.dutch": "Dutch",
    "1101_vic.economics": "Economics",
    "1101_vic.english_and_english_as_an_additional_language": "English and English as an Additional Language",
    "1101_vic.english_language": "English Language",
    "1101_vic.environmental_science": "Environmental Science",
    "1101_vic.extended_investigation": "Extended Investigation",
    "1101_vic.filipino": "Filipino",
    "1101_vic.food_studies": "Food Studies",
    "1101_vic.foundation_english": "Foundation English",
    "1101_vic.french": "French",
    "1101_vic.further_mathematics": "Further Mathematics",
    "1101_vic.general_mathematics": "General Mathematics",
    "1101_vic.geography": "Geography",
    "1101_vic.german": "German",
    "1101_vic.greek": "Greek",
    "1101_vic.health_and_human_development": "Health and Human Development",
    "1101_vic.hebrew": "Hebrew",
    "1101_vic.hindi": "Hindi",
    "1101_vic.history": "History",
    "1101_vic.hungarian": "Hungarian",
    "1101_vic.indigenous_languages_of_victoria_revival_and_reclamation": "Indigenous Languages of Victoria: Revival and Reclamation",
    "1101_vic.indonesian_first_language": "Indonesian First Language",
    "1101_vic.indonesian_second_language": "Indonesian Second Language",
    "1101_vic.industry_and_enterprise": "Industry and Enterprise",
    "1101_vic.italian": "Italian",
    "1101_vic.japanese_first_language": "Japanese First Language",
    "1101_vic.japanese_second_language": "Japanese Second Language",
    "1101_vic.karen": "Karen",
    "1101_vic.khmer": "Khmer",
    "1101_vic.korean_first_language": "Korean First Language",
    "1101_vic.korean_second_language": "Korean Second Language",
    "1101_vic.latin": "Latin",
    "1101_vic.legal_studies": "Legal Studies",
    "1101_vic.literature": "Literature",
    "1101_vic.macedonian": "Macedonian",
    "1101_vic.maltese": "Maltese",
    "1101_vic.mathematical_methods": "Mathematical Methods",
    "1101_vic.media": "Media",
    "1101_vic.music": "Music",
    "1101_vic.outdoor_and_environmental_studies": "Outdoor and Environmental Studies",
    "1101_vic.persian": "Persian",
    "1101_vic.philosophy": "Philosophy",
    "1101_vic.physical_education": "Physical Education",
    "1101_vic.physics": "Physics",
    "1101_vic.polish": "Polish",
    "1101_vic.portuguese": "Portuguese",
    "1101_vic.product_design_and_technology": "Product Design and Technology",
    "1101_vic.psychology": "Psychology",
    "1101_vic.punjabi": "Punjabi",
    "1101_vic.ramil": "Ramil",
    "1101_vic.religion_and_society": "Religion and Society",
    "1101_vic.romanian": "Romanian",
    "1101_vic.russian": "Russian",
    "1101_vic.serbian": "Serbian",
    "1101_vic.sinhala": "Sinhala",
    "1101_vic.sociology": "Sociology",
    "1101_vic.spanish": "Spanish",
    "1101_vic.specialist_mathematics": "Specialist Mathematics",
    "1101_vic.studio_arts": "Studio Arts",
    "1101_vic.swedish": "Swedish",
    "1101_vic.systems_engineering": "Systems Engineering",
    "1101_vic.texts_and_traditions": "Texts and Traditions",
    "1101_vic.theatre_studies": "Theatre Studies",
    "1101_vic.turkish": "Turkish",
    "1101_vic.vietnamese_first_language": "Vietnamese First Language",
    "1101_vic.vietnamese_second_language": "Vietnamese Second Language",
    "1101_vic.visual_communication_design": "Visual Communication Design",
    "1101_vic.yiddish": "Yiddish",
    "1101_wa.aboriginal_and_intercultural_studies": "Aboriginal and Intercultural Studies",
    "1101_wa.aboriginal_languages_of_western_australia": "Aboriginal Languages of Western Australia",
    "1101_wa.accounting_and_finance": "Accounting and Finance",
    "1101_wa.agribusiness": "Agribusiness",
    "1101_wa.agricultural_science_and_technology": "Agricultural Science and Technology",
    "1101_wa.ancient_history": "Ancient History",
    "1101_wa.animal_production_systems": "Animal Production Systems",
    "1101_wa.applied_information_technology": "Applied Information Technology",
    "1101_wa.arabic": "Arabic",
    "1101_wa.armenian": "Armenian",
    "1101_wa.auslan": "Auslan",
    "1101_wa.automotive_engineering_and_technology": "Automotive Engineering and Technology",
    "1101_wa.automotive_vet_industry_specific": "Automotive (VET industry specific)",
    "1101_wa.aviation": "Aviation",
    "1101_wa.bengali": "Bengali",
    "1101_wa.biology": "Biology",
    "1101_wa.bosnian": "Bosnian",
    "1101_wa.building_and_construction": "Building and Construction",
    "1101_wa.business_and_financial_services_vet_industry_specific": "Business and Financial Services (VET industry specific)",
    "1101_wa.business_management_and_enterprise": "Business Management and Enterprise",
    "1101_wa.career_and_enterprise": "Career and Enterprise",
    "1101_wa.careers_and_employability": "Careers and Employability",
    "1101_wa.chemistry": "Chemistry",
    "1101_wa.children_family_and_the_community": "Children, Family and the Community",
    "1101_wa.chin_hakha": "Chin Hakha",
    "1101_wa.chinese_background_language": "Chinese: Background Language",
    "1101_wa.chinese_first_language": "Chinese: First Language",
    "1101_wa.chinese_second_language": "Chinese: Second Language",
    "1101_wa.community_services_and_health_vet_industry_specific": "Community Services and Health (VET industry specific)",
    "1101_wa.computer_science": "Computer Science",
    "1101_wa.construction_industries_vet_industry_specific": "Construction Industries (VET industry specific)",
    "1101_wa.creative_industries_vet_industry_specific": "Creative Industries (VET industry specific)",
    "1101_wa.croatian": "Croatian",
    "1101_wa.dance": "Dance",
    "1101_wa.design": "Design",
    "1101_wa.drama": "Drama",
    "1101_wa.dutch": "Dutch",
    "1101_wa.earth_and_environmental_science": "Earth and Environmental Science",
    "1101_wa.economics": "Economics",
    "1101_wa.engineering_studies": "Engineering Studies",
    "1101_wa.engineering_vet_industry_specific": "Engineering (VET Industry specific)",
    "1101_wa.english": "English",
    "1101_wa.english_as_an_additional_language_or_dialect": "English as an Additional Language or Dialect",
    "1101_wa.filipino": "Filipino",
    "1101_wa.food_science_and_technology": "Food Science and Technology",
    "1101_wa.french_background_language": "French: Background Language",
    "1101_wa.french_second_language": "French: Second Language",
    "1101_wa.geography": "Geography",
    "1101_wa.german_background_language": "German: Background Language",
    "1101_wa.german_second_language": "German: Second Language",
    "1101_wa.health_and_physical_education": "Health and Physical Education",
    "1101_wa.health_physical_and_outdoor_education": "Health, Physical and Outdoor Education",
    "1101_wa.health_studies": "Health Studies",
    "1101_wa.hebrew": "Hebrew",
    "1101_wa.hindi_background_language": "Hindi: Background Language",
    "1101_wa.hindi_second_language": "Hindi: Second Language",
    "1101_wa.hospitality_and_tourism_vet_industry_specific": "Hospitality and Tourism (VET industry specific)",
    "1101_wa.human_biology": "Human Biology",
    "1101_wa.humanities_and_social_sciences_in_action": "Humanities and Social Sciences in Action",
    "1101_wa.hungarian": "Hungarian",
    "1101_wa.indonesian_background_language": "Indonesian: Background Language",
    "1101_wa.indonesian_second_language": "Indonesian: Second Language",
    "1101_wa.information_and_communications_technology_vet_industry_specific": "Information and Communications Technology (VET industry specific)",
    "1101_wa.italian_background_language": "Italian: Background Language",
    "1101_wa.italian_second_language": "Italian: Second Language",
    "1101_wa.japanese_background_language": "Japanese: Background Language",
    "1101_wa.japanese_second_language": "Japanese: Second Language",
    "1101_wa.karen": "Karen",
    "1101_wa.khmer": "Khmer",
    "1101_wa.korean_background_language": "Korean: Background Language",
    "1101_wa.korean_second_language": "Korean: Second Language",
    "1101_wa.latin": "Latin*",
    "1101_wa.literature": "Literature",
    "1101_wa.macedonian": "Macedonian",
    "1101_wa.marine_and_maritime_studies": "Marine and Maritime Studies",
    "1101_wa.materials_design_and_technology": "Materials Design and Technology",
    "1101_wa.mathematics": "Mathematics",
    "1101_wa.mathematics_applications": "Mathematics Applications",
    "1101_wa.mathematics_essential": "Mathematics Essential",
    "1101_wa.mathematics_methods": "Mathematics Methods",
    "1101_wa.mathematics_specialist": "Mathematics Specialist",
    "1101_wa.media_production_and_analysis": "Media Production and Analysis",
    "1101_wa.modern_greek": "Modern Greek",
    "1101_wa.modern_history": "Modern History",
    "1101_wa.music": "Music",
    "1101_wa.nepali": "Nepali",
    "1101_wa.outdoor_education": "Outdoor Education",
    "1101_wa.persian": "Persian",
    "1101_wa.philosophy_and_ethics": "Philosophy and Ethics",
    "1101_wa.physical_education_studies": "Physical Education Studies",
    "1101_wa.physics": "Physics",
    "1101_wa.plant_production_systems": "Plant Production Systems",
    "1101_wa.polish": "Polish",
    "1101_wa.politics_and_law": "Politics and Law",
    "1101_wa.portuguese": "Portuguese",
    "1101_wa.primary_industries_vet_industry_specific": "Primary Industries (VET industry specific)",
    "1101_wa.psychology": "Psychology",
    "1101_wa.punjabi_background_language": "Punjabi: Background Language",
    "1101_wa.punjabi_second_language": "Punjabi: Second Language",
    "1101_wa.religion_and_life": "Religion and Life",
    "1101_wa.romanian": "Romanian",
    "1101_wa.russian": "Russian",
    "1101_wa.science_in_practice": "Science in Practice",
    "1101_wa.serbian": "Serbian",
    "1101_wa.sinhala": "Sinhala",
    "1101_wa.spanish": "Spanish",
    "1101_wa.sport_and_recreation_vet_industry_specific": "Sport and Recreation (VET industry specific)",
    "1101_wa.swedish": "Swedish",
    "1101_wa.tamil_background_language": "Tamil: Background Language",
    "1101_wa.tamil_second_language": "Tamil: Second Language",
    "1101_wa.turkish": "Turkish",
    "1101_wa.vietnamese": "Vietnamese",
    "1101_wa.visual_arts": "Visual Arts"
  }
}
